import React, { Component } from 'react';
import { Link } from "react-router";
import { firebase, auth } from '../firebase';
import Nav from '../components/Nav';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      errorMessage: "",
      loading: false,
    };
  }

  componentDidMount() {
    let load = false;
    auth.onAuthStateChanged((user) => {
      if (user !== null && load === false) {
        window.location.pathname = "/";
      }
      load = true;
    });
  }

  SignIn = () => {
    this.setState({ loading: true }); // Show the loading overlay and image

    auth.signInWithEmailAndPassword(this.state.email, this.state.password)
      .then((user) => {
        if (user !== null) {
          window.location.pathname = "/profil";
        }
      }).catch((error) => {
        console.log(error);
        this.setState({
          loading: false, // Hide the loading overlay and image
          errorMessage: this.getErrorMessage(error),
        });
      });
  }

  handleInputChange = (e) => {
    const { id, value } = e.target;
    this.setState({ [id]: value });
  }

  handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      this.SignIn();
    }
  }

  getErrorMessage = (error) => {
    if (error.code === "auth/wrong-password") {
      return "Hatalı şifre girildi.";
    } else if (error.code === "auth/invalid-email") {
      return "Lütfen geçerli bir E-Posta adresi girin.";
    } else {
      return "Bir sorun oluştu.";
    }
  }

  render() {
    return (
      <div>
        <Nav />
        <div className="ana">
          {this.state.loading && (
            <>
              <div className="overlay"></div>
              <img src="/loading.svg" className="overlay-img" />
            </>
          )}

          <p style={{ fontWeight: "bold", userSelect: "none" }}>Giriş Yap</p>
          {this.state.errorMessage && (
            <div className="errorMessage">{this.state.errorMessage}</div>
          )}

          <div>
            <input 
              id="email" 
              type="email" 
              placeholder="E-Posta" 
              value={this.state.email} 
              onChange={this.handleInputChange} 
              onKeyDown={this.handleKeyPress} 
              required 
            />
          </div>
          <div style={{ marginTop: 10 }}>
            <input 
              id="password" 
              type="password" 
              placeholder="Şifre" 
              value={this.state.password} 
              onChange={this.handleInputChange} 
              onKeyDown={this.handleKeyPress} 
              required 
            />
          </div>

          <button onClick={this.SignIn} id="signbutton">Giriş Yap</button><br /><br />
          <label className="text">
            Henüz bir hesabın yok mu? Sorun değil! <Link to="/kayit-ol">Kaydol.</Link>
          </label>

          <style>{`
            .ana {
              position: fixed;
              width: 100%;
              height: 100%;
              padding-top: 200px;
              text-align: center;
              font-size: 30px;
              background: #F57029;
              color: #fff;
            }

            .overlay {
              top: 0;
              left: 0;
              background: #000;
              position: fixed;
              width: 100%;
              height: 100%;
              opacity: 0.7;
              z-index: 888;
              display: block;
            }

            .overlay-img {
              top: 50%;
              left: 50%;
              width: 150px;
              height: 150px;
              position: fixed;
              margin-top: -75px;
              margin-left: -75px;
              z-index: 899;
              display: block;
            }

            .errorMessage {
              color: #000;
              font-size: 16px;
              font-weight: bold;
              margin-top: -30px;
              margin-bottom: 10px;
              padding: 10px 0;
            }

            input {
              padding-left: 15px;
              border: 0;
              border-radius: 25px;
              width: 300px;
              height: 40px;
              outline: none;
              transition: .2s;
            }

            input:focus {
              background: #ccc;
            }

            button {
              margin-top: 30px;
              width: 100px;
              height: 30px;
              border: 0;
              border-radius: 20px;
              background: #2f2d33;
              color: #fff;
              outline: none;
              transition: .2s;
            }

            button:hover {
              background: #5b5b5c;
            }

            .text {
              font-size: 14px;
              display: block;
              margin: auto;
              max-width: 70%;
            }

            .text a {
              color: #000;
            }

            @media (max-width: 623px) {
              .ana {
                position: fixed;
                padding: 50px 0px;
                margin: 0;
                height: 100%;
              }
            }
          `}</style>
        </div>
      </div>
    );
  }
}

export default Login;